<<template>
  <div class="login-page">
    <p class="title">
      <span class="el-icon-warning"></span>
      {{ `密码已过期，请修改密码` }}
    </p>
    <el-form size="small" ref="ruleForm" label-width="80px" label="top" :model="ruleForm" :rules="rules"
      class="demo-ruleForm">
      <el-form-item :label="$t('message.table.oldPW')" prop="oldLoginPwd">
        <el-input style="width: 100%;" v-model="ruleForm.oldLoginPwd" type="password"></el-input>
      </el-form-item>
      <el-form-item :label="$t('message.table.newPW')" prop="loginPwd">
        <el-input style="width: 100%;" v-model="ruleForm.loginPwd" type="password"></el-input>
      </el-form-item>
      <el-form-item :label="$t('message.table.newPWagain')" prop="loginPwdAgain">
        <el-input style="width: 100%;" v-model="ruleForm.loginPwdAgain" type="password"></el-input>
      </el-form-item>

      <el-button type="primary" :loading="loading" @click="handleSubmit('ruleForm')">修改密码并登录</el-button>
    </el-form>
  </div>
</template>

  <script>
  import axios from 'axios';
  export default {
    data() {
      return {
        ruleForm: {
          oldLoginPwd: "",
          loginPwd: '',
          loginPwdAgain: "",
        },
        rules: {
          oldLoginPwd: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur' }
          ],
          loginPwd: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur' }
          ],
          loginPwdAgain: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur' }
          ],
        },
        loading: false,

      }
    },
    methods: {
      handleSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var session = window.sessionStorage.getItem('userContext');
            session = JSON.parse(session);
            if (this.ruleForm.loginPwd == this.ruleForm.loginPwdAgain) {
              //console.log(this.ruleForm.loginPwd);
              var obj = {
                id: session.id,
                oldLoginPwd: this.ruleForm.oldLoginPwd,
                loginPwd: this.ruleForm.loginPwd,
              };
              this.loading = true;
              axios.post('/pmdm/admin/user/changePwd', obj)
                .then(res => {
                  //console.log(res);
                  if (res.data.code == 200) {
                    this.$message({
                      // title: "登入成功",
                      message: this.$t("message.title.welcome"),
                      type: "success",
                      showClose: true,
                    });
                    this.$router.push("/home");
                  } else {
                    this.$message.error(this.$t('message.error.change'));
                  };
                })
                .catch(function (error) {
                  console.log(error);
                })
                .finally(_ => {
                  this.loading = false;
                })
            } else {
              this.$message.error(this.$t('message.table.PWnotSame'));
            }
            //console.log(session);
          } else {
            this.$message.error(this.$t('message.error.save'));
            return false;
          }
        });
      },
    },
  }
</script>

  <style scoped>
  .login-page {
    float: left;
    margin-left: 20px;
    padding: 25px 35px;
    box-sizing: border-box;
    width: 400px;
    height: 450px;
    margin-top: 80px;
    background: #fff;
    overflow: hidden;
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }

  .title {
    font-size: 14px;
  }
</style>